module.exports = __webpack_public_path__ + "img/mobile_warn.99ff9ed8.png";